import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';

interface DialogData {
  message?: string;
  isReadOnly: boolean;
}

@Component({
  selector: 'app-dialog-order-note',
  templateUrl: './dialog-order-note.component.html',
  styleUrls: ['./dialog-order-note.component.css']
})
export class DialogOrderNoteComponent implements OnInit {

  public static displayDialog(dialog: MatDialog,
                              message: string | undefined,
                              isReadOnly: boolean): MatDialogRef<DialogOrderNoteComponent, string | undefined> {
    const dialogData: DialogData = { message: message, isReadOnly };
    return dialog.open<DialogOrderNoteComponent, DialogData, string | undefined>(DialogOrderNoteComponent, {data: dialogData, minWidth: '50%'});
  }

  public message = this.data?.message;

  constructor(public dialogRef: MatDialogRef<DialogOrderNoteComponent, string | undefined>,
              @Inject(<DialogData|any>MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void { }

  public onClose(save: boolean) {
    // Dialog retourne undefine si on ne veux pas sauvegarder sinon retourne le text
    this.dialogRef.close(save ? this.message : undefined);
  }

  public get isReadOnly(): boolean {
    return this.data?.isReadOnly;
  }
}
